export default function(editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;

  if (c.blocks.indexOf(c.refs.drapcodeIconsRef) >= 0) {
    bm.add(c.refs.drapcodeIconsRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg>
          <div class="gjs-block-label">${c.label}</div>`,
      category: c.category,
      activate: true,
      select: true,
      content: `
        <i class='${pfx}' style="width:10%" data-js=${c.refs.drapcodeIconsRef} data-gjs-type=${c.refs.drapcodeIconsRef}>
        </i>`,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info">
          <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/basic-component-icons" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.label
      }?"></i>
          </a>
        </span>
      `,
    });
  }
}
